import PropTypes from 'prop-types';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import styles from './FilterNodeLabel.less';

class FilterNodeLabel extends React.PureComponent {
  render() {
    const {label} = this.props;
    return (
      <span className={styles.dlFilterNodeLabel}>
        <FormattedMessage id={label} description={'filter node label'} />
      </span>
    );
  }
}

FilterNodeLabel.displayName = 'FilterNodeLabel';

FilterNodeLabel.propTypes = {
  label: PropTypes.string,
};

FilterNodeLabel.defaultProps = {
  label: '',
};

export default FilterNodeLabel;
